/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Action_WrappedInputs */

const en_us2_search_preview_action_wrapped = /** @type {(inputs: Search_Preview_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cards to look back on and share your training weeks.`)
};

const pt_br2_search_preview_action_wrapped = /** @type {(inputs: Search_Preview_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cards para rever e compartilhar suas semanas de treino.`)
};

const es_419_search_preview_action_wrapped = /** @type {(inputs: Search_Preview_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjetas para repasar y compartir tus semanas de entrenamiento.`)
};

const pt_pt2_search_preview_action_wrapped = /** @type {(inputs: Search_Preview_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartões para rever e partilhar as tuas semanas de treino.`)
};

const fr_fr2_search_preview_action_wrapped = /** @type {(inputs: Search_Preview_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des cartes pour revoir et partager tes semaines d'entraînement.`)
};

const de_de2_search_preview_action_wrapped = /** @type {(inputs: Search_Preview_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karten, um auf deine Trainingswochen zurückzublicken und sie zu teilen.`)
};

const it_it2_search_preview_action_wrapped = /** @type {(inputs: Search_Preview_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schede per ripercorrere e condividere le tue settimane di allenamento.`)
};

/**
* | output |
* | --- |
* | "Cards to look back on and share your training weeks." |
*
* @param {Search_Preview_Action_WrappedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_action_wrapped = /** @type {((inputs?: Search_Preview_Action_WrappedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Action_WrappedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_action_wrapped(inputs)
	if (locale === "es-419") return es_419_search_preview_action_wrapped(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_action_wrapped(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_action_wrapped(inputs)
	if (locale === "de-DE") return de_de2_search_preview_action_wrapped(inputs)
	if (locale === "it-IT") return it_it2_search_preview_action_wrapped(inputs)
	return en_us2_search_preview_action_wrapped(inputs)
});
export { search_preview_action_wrapped as "search.preview_action_wrapped" }